import DockWithMedia from '../../../types/DockWithMedia';
import UIParameters from '../../../types/UIParameters';

const sortedAndFilteredDocks = (
    docks: Record<string, DockWithMedia>,
    uiParameters?: UIParameters
) => {
    let visibleDocks = Object.values(docks);

    if (uiParameters?.filterDocks) {
        visibleDocks = visibleDocks.filter(
            (dock) => uiParameters.filterDocks.indexOf(dock.id) >= 0
        );
    }

    return visibleDocks.sort((a, b) => a.sortingOrder - b.sortingOrder);
};

export default sortedAndFilteredDocks;
